import styles from './CardTitle.module.scss';

export function CardTitle({ title } : {title : string}) {
    return (
            <span className={styles['title']} >
                {title}
            </span>
    );

}